import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import ConfirmCopyModal from "./ConfirmCopyTagModal";
import { DeleteAndMoveTags } from "components/modals/DeleteMoveItems";

interface Props {
  listUrl: string
  linkedItemCount: number
  mainArea: server.dto.MainAreas
  data: server.dto.OptionsPanelDataV2
  tag: server.dto.TagSmall
}

const TagEditOptionsPanel = (props: Props) => {
  const { tag, mainArea, data } = props;
  const [isDeleting, setIsDeleting] = React.useState(false);
  const [isCopying, setIsCopying] = React.useState(false);

  return <>
    <ConfirmCopyModal
      tag={tag}
      mainArea={mainArea}
      isOpen={isCopying}
      onClose={() => { setIsCopying(false); }}
    />
    <DeleteAndMoveTags
      tagId={tag.tagId}
      mainArea={mainArea}
      isOpen={isDeleting}
      onClose={() => { setIsDeleting(false); }}
      afterDeleteRedirectUrl={props.listUrl}
      associatedItemCount={props.linkedItemCount}
    />
    <GeneralOptionsPanel data={data} links={[{
      text: RESX.Buttons.ListView,
      visible: true,
      href: routes.tag_List(mainArea).absolute
    }, {
      text: RESX.Buttons.btnCopy,
      visible: true,
      onClick: () => { setIsCopying(true); }
    }, {
      text: RESX.Buttons.btnDelete,
      visible: true,
      onClick: () => { setIsDeleting(true); }
    }]} />
  </>;
};

export default TagEditOptionsPanel;